import { BRAZIL_DISPATCH_WAVE_POLICY_V1 } from './dispatch-money.js';
/** R2: the owner's Brazilian defaults for a Send that ends after its pickup. */
export const BRAZIL_SEND_AFTER_PICKUP_PROPOSAL = {
    senderCancels: { chargeSender: 'FULL', proportionalBasisPoints: 0, courierPaid: 'WITH_CHARGE' },
    recipientUnreachable: { chargeSender: 'FULL', proportionalBasisPoints: 0, courierPaid: 'WITH_CHARGE', returnToSender: true, returnCharged: false, returnChargeBasisPoints: 0 },
    courierFault: { chargeSender: 'NONE', proportionalBasisPoints: 0, courierPaid: 'NONE' },
    // D858 (owner 2026-10-31): the platform's own failure never charges the sender; what Vello pays the courier is the owner's to publish later - NONE until then (fail-safe).
    platformFault: { courierPaidByPlatform: 'NONE', proportionalBasisPoints: 0 },
    cashCollectedAtPickup: 'COVERS_CHARGE',
};
/** R4: the escalation of the timed auto-pause, in seconds: 5, 10 and 20 minutes (the last repeats). */
export const BRAZIL_AUTO_PAUSE_DURATIONS_SECONDS = [300, 600, 1200];
/**
 * R3 + R4: Brazil's `dispatch.wavePolicy` v1 with the timed auto-pause. Everything but `autoPause` is v1 as published; `countReofferMisses` is left out on purpose (absent = off:
 * the re-offers of one ride are one miss).
 */
export const BRAZIL_DISPATCH_WAVE_POLICY_TIMED_AUTO_PAUSE_PROPOSAL = {
    ...BRAZIL_DISPATCH_WAVE_POLICY_V1,
    autoPause: { ...BRAZIL_DISPATCH_WAVE_POLICY_V1.autoPause, durationsSeconds: BRAZIL_AUTO_PAUSE_DURATIONS_SECONDS, resetDaily: true, notify: true },
};
//# sourceMappingURL=proposals-d856.js.map